<template>
  <form
    class="w-full max-w-md flex flex-col bg-white gap-4 p-6 rounded-2xl border border-slate-200 m-6 shadow-xl shadow-primary/2"
    @submit="onSubmit"
  >
    <label class="text-center mb-4">
      <img
        src="/AppIcon.svg"
        alt="logo"
        class="w-20 h-20 mx-auto mb-2"
      >
      <h1 class="text-2xl font-bold text-foreground/80">
        登录
      </h1>
    </label>

    <FormField
      v-slot="{ componentField }"
      name="phone"
    >
      <FormItem>
        <FormLabel>手机号</FormLabel>
        <FormControl>
          <Input
            type="tel"
            placeholder="请输入手机号"
            v-bind="componentField"
            autocomplete="tel"
          />
        </FormControl>
        <FormMessage />
      </FormItem>
    </FormField>

    <FormField
      v-slot="{ componentField }"
      name="password"
    >
      <FormItem>
        <FormLabel>密码</FormLabel>
        <FormControl>
          <Input
            type="password"
            placeholder="请输入密码"
            v-bind="componentField"
            autocomplete="current-password"
          />
        </FormControl>
        <FormMessage />
      </FormItem>
    </FormField>

    <Button
      type="submit"
      :disabled="pending"
      class="w-full mt-2"
    >
      <Icon
        v-if="pending"
        name="lucide:loader-2"
        class="mr-2 h-4 w-4 animate-spin"
      />
      {{ pending ? '登录中...' : '登录' }}
    </Button>

    <div class="text-center mt-4">
      <p class="text-sm text-slate-500">
        还没有账号？
        <NuxtLink
          to="/register"
          class="text-blue-600 hover:text-blue-800 font-medium"
        >
          立即注册
        </NuxtLink>
      </p>
    </div>
  </form>
</template>

<script setup lang="ts">
import { toTypedSchema } from '@vee-validate/zod'
import { useForm } from 'vee-validate'
import { toast } from 'vue-sonner'
import * as z from 'zod'
import { FetchError } from 'ofetch'

const { login } = useAuth()
const route = useRoute()

definePageMeta({
  layout: 'centered',
})

// 获取重定向路径
const redirectPath = computed(() => {
  const redirect = route.query.redirect as string
  return redirect ? decodeURIComponent(redirect) : '/'
})

// 表单验证模式
const formSchema = toTypedSchema(z.object({
  phone: z.string()
    .min(11, '手机号必须为11位')
    .max(11, '手机号必须为11位')
    .regex(/^1[3-9]\d{9}$/, '请输入正确的手机号'),
  password: z.string()
    .min(6, '密码至少6位')
    .max(50, '密码不能超过50位'),
}))

const form = useForm({
  validationSchema: formSchema,
  initialValues: {
    phone: '',
    password: '',
  },
})

const onSubmit = form.handleSubmit(async (values) => {
  try {
    pending.value = true
    await login({
      phone: values.phone,
      password: values.password,
    })
    toast.success('登录成功')
    navigateTo(redirectPath.value, { replace: true })
  }
  catch (error) {
    if (error instanceof FetchError) {
      if (error.status === 401) {
        toast.error('手机号或密码错误')
      }
      else if (error.status === 500) {
        toast.error('服务器错误')
      }
      else {
        toast.error('登录失败')
        console.error(error)
      }
    }
  }
  finally {
    pending.value = false
  }
})

const pending = ref(false)
</script>
